export default __webpack_public_path__ + "static/media/prepare-questions.852a4e95.png";